import { setStockIntegrationAction } from '@/context/display';
import { store } from '@/context/store';

export function setStockIntegration(
    stockInt: string | undefined
): void {
    const state = store.getState();
    if (!stockInt) {
        return;
    }

    if (stockInt !== state.displayReducer.stockIntegration) {
        store.dispatch(setStockIntegrationAction(stockInt));
    }
    
}
